function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1912(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 61.6,
    height: 41.46,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.922857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.8,
    y: 20.73,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41.46,
    width: 61.6,
    height: 43.65,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.235714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.8,
    y: 63.285,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 85.11,
    width: 61.6,
    height: 51.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.358
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.8,
    y: 111.005,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 136.9,
    width: 61.6,
    height: 56.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.465
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.8,
    y: 165.29500000000002,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 193.7,
    width: 61.6,
    height: 59.92,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.8,
    y: 223.66,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 253.62,
    width: 61.6,
    height: 61.02,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.255
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.8,
    y: 284.13,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 314.64,
    width: 61.6,
    height: 61.02,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.8,
    y: 345.15,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 375.66,
    width: 61.6,
    height: 78.7,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.266666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.8,
    y: 415.01000000000005,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 454.36,
    width: 61.6,
    height: 79.17,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.844444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.8,
    y: 493.945,
    fontFamily: "Arial"
  }, "\n        St._Lucie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 533.53,
    width: 61.6,
    height: 83.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.8,
    y: 575.15,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 616.76,
    width: 61.6,
    height: 83.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.266666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.8,
    y: 658.38,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.6,
    y: 0,
    width: 73.64,
    height: 71.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.247142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.42,
    y: 35.865,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.24,
    y: 0,
    width: 74.71,
    height: 71.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.970000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.595,
    y: 35.865,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.95,
    y: 0,
    width: 74.84,
    height: 71.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.96625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.37,
    y: 35.865,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.79,
    y: 0,
    width: 74.98,
    height: 71.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.955
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.28000000000003,
    y: 35.865,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.77,
    y: 0,
    width: 79.28,
    height: 71.73,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.247142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 399.40999999999997,
    y: 35.865,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.05,
    y: 0,
    width: 82.77,
    height: 71.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.970000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.435,
    y: 35.865,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.82,
    y: 0,
    width: 88.68,
    height: 71.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.247142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.1600000000001,
    y: 35.865,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610.51,
    y: 0,
    width: 89.49,
    height: 71.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.9325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.255,
    y: 35.865,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.6,
    y: 71.73,
    width: 91.11,
    height: 70.88,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.86
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.155,
    y: 107.17,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.6,
    y: 142.61,
    width: 91.11,
    height: 71.09,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.848333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.155,
    y: 178.15500000000003,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.6,
    y: 213.7,
    width: 91.11,
    height: 75.53,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.176666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.155,
    y: 251.46499999999997,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.6,
    y: 289.23,
    width: 91.11,
    height: 76.06,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.212
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.155,
    y: 327.26,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.6,
    y: 365.29,
    width: 91.11,
    height: 76.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.155,
    y: 403.64000000000004,
    fontFamily: "Arial"
  }, "\n        Palm_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.6,
    y: 441.99,
    width: 91.11,
    height: 81.56,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.651428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.155,
    y: 482.77,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.6,
    y: 523.55,
    width: 91.11,
    height: 85.79,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.4475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.155,
    y: 566.4449999999999,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.6,
    y: 609.34,
    width: 91.11,
    height: 90.66,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.3325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.155,
    y: 654.6700000000001,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.72,
    y: 71.73,
    width: 81.39,
    height: 105.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.627142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.415,
    y: 124.37,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.11,
    y: 71.73,
    width: 81.75,
    height: 105.28,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.985,
    y: 124.37,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.86,
    y: 71.73,
    width: 93.93,
    height: 105.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.74125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.82500000000005,
    y: 124.37,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.79,
    y: 71.73,
    width: 94.85,
    height: 105.28,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.549999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.21500000000003,
    y: 124.37,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.63,
    y: 71.73,
    width: 96.68,
    height: 105.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 552.97,
    y: 124.37,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.31,
    y: 71.73,
    width: 98.69,
    height: 105.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.869
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.655,
    y: 124.37,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.72,
    y: 177.02,
    width: 117.79,
    height: 93.62,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.402222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.615,
    y: 223.83,
    fontFamily: "Arial"
  }, "\n        St._Johns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.72,
    y: 270.63,
    width: 117.79,
    height: 96.07,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.011666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.615,
    y: 318.66499999999996,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.72,
    y: 366.7,
    width: 117.79,
    height: 103.03,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.171666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.615,
    y: 418.215,
    fontFamily: "Arial"
  }, "\n        DeSoto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.72,
    y: 469.73,
    width: 117.79,
    height: 114.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.615,
    y: 526.85,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.72,
    y: 583.96,
    width: 117.79,
    height: 116.04,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.615,
    y: 641.98,
    fontFamily: "Arial"
  }, "\n        Pinellas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.51,
    y: 177.02,
    width: 139.38,
    height: 113.89,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.981666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.2,
    y: 233.965,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.89,
    y: 177.02,
    width: 143.62,
    height: 113.89,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.7,
    y: 233.965,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.51,
    y: 177.02,
    width: 146.49,
    height: 113.89,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 626.755,
    y: 233.965,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.51,
    y: 290.91,
    width: 128.67,
    height: 133.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.1675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 334.84499999999997,
    y: 357.65500000000003,
    fontFamily: "Arial"
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.51,
    y: 424.4,
    width: 128.67,
    height: 137.54,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.444999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 334.84499999999997,
    y: 493.16999999999996,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.51,
    y: 561.94,
    width: 128.67,
    height: 138.06,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.444999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 334.84499999999997,
    y: 630.97,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399.17,
    y: 290.91,
    width: 148.19,
    height: 134.38,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.7975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.265,
    y: 358.1,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.36,
    y: 290.91,
    width: 152.64,
    height: 134.38,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 33.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.6800000000001,
    y: 358.1,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399.17,
    y: 425.29,
    width: 137.01,
    height: 274.71,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.417499999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.675,
    y: 562.645,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.18,
    y: 425.29,
    width: 163.82,
    height: 274.71,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.763999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.0899999999999,
    y: 562.645,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1912);
export default __webpack_public_path__ + "static/media/1912.3826759722796a611e61cec897b8bab0.svg";
export { ForwardRef as ReactComponent };